import { parse } from 'gradient-parser';

const DEFAULT_LINEAR_ORIENTATION = { type: 'angular', value: '180', unit: 'deg' };
const DEFAULT_RADIAL_ORIENTATION = [
  {
    type: 'shape',
    value: 'circle',
    at: {
      type: 'position',
      value: {
        x: { type: '%', value: '50' },
        y: { type: '%', value: '50' },
      },
    },
  },
];

const mapColorStop = (stop, index, total) => {
  const values = stop.value.map(Number);
  const [h, s, l, a = 1] = values;
  const defaultPercent = total > 1 ? (index / (total - 1)) * 100 : 0;

  return {
    id: String(index),
    type: 'hsla',
    value: [String(h), String(s / 100), String(l / 100), String(a)],
    length: stop.length || { type: '%', value: String(defaultPercent) },
  };
};

const buildGradientModelByString = (gradientString) => {
  let parsed;
  try {
    [parsed] = parse(gradientString);
  } catch (e) {
    return null;
  }

  if (!parsed) return null;

  const { colorStops: rawStops } = parsed;
  if (!rawStops || rawStops.length === 0) return null;

  let { orientation } = parsed;

  if (parsed.type === 'linear-gradient') {
    if (!orientation) {
      orientation = DEFAULT_LINEAR_ORIENTATION;
    } else if (orientation.type === 'angular') {
      orientation = { ...orientation, unit: 'deg' };
    }
  }

  if (parsed.type === 'radial-gradient' && !orientation) {
    orientation = DEFAULT_RADIAL_ORIENTATION;
  }

  const colorStops = rawStops.map((stop, index) => mapColorStop(stop, index, rawStops.length));

  return {
    type: parsed.type,
    orientation,
    colorStops,
    activeColorStopId: colorStops[0].id,
  };
};

export default buildGradientModelByString;
